import React, {useEffect} from "react";
import PropTypes from "prop-types";

export default function ReactDocumentTitle({title}) {
  useEffect(() => {
    const nextTitle = (title || '') + ' - Workshop Butler';

    if (nextTitle !== document.title) {
      document.title = nextTitle;
    }
  }, [title]);

  return null;
}

ReactDocumentTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
